import type { LoggerService } from "@/services/abstract/LoggerService";
import { makeMessageHandler } from "@/services/poc/handlers/makeMessageHandler";

export const createUploadSuccessfulHandler = (loggerService: LoggerService) =>
  makeMessageHandler(
    'uploadSuccessful',
    'six3ro:p2p:handlers:upload-successful',
    loggerService,
    (message) => ({
      type: 'uploadSuccessful',
      data: {
        cid: message.cid,
        sixId: message.sixId,
        sender: message.sender,
        messageTimestamp: message.timestamp,
      },
    })
  );
